import FeatureGrid from "components/landing/feature-grid"
import { getImgSrcSet } from "helpers/image"

const data = [
  {
    image: {
      desktop: "card_d_01_c258df94a0/card_d_01_c258df94a0.jpg",
      mobile: "card_m_01_9e8faf3d06/card_m_01_9e8faf3d06.jpg",
    },
    title: "Rings",
    url: "/womens-rings",
  },
  {
    image: {
      desktop: "card_d_02_72ce99e591/card_d_02_72ce99e591.jpg",
      mobile: "card_m_02_69a9bf3f4d/card_m_02_69a9bf3f4d.jpg",
    },
    title: "Necklaces",
    url: "/womens-necklaces",
  },
  {
    image: {
      desktop: "card_d_03_3e23578ddf/card_d_03_3e23578ddf.jpg",
      mobile: "card_m_03_9c376ad06e/card_m_03_9c376ad06e.jpg",
    },
    title: "Earrings",
    url: "/earrings",
  },
  {
    image: {
      desktop: "card_d_04_ad639f5978/card_d_04_ad639f5978.jpg",
      mobile: "card_m_04_bf30e833b0/card_m_04_bf30e833b0.jpg",
    },
    title: "Bracelets",
    url: "/womens-bracelets",
  },
]

const element = {
  contain: true,
  data: {
    items: data.map((item) => ({
      cta: "Shop Now",
      image: {
        fallback: `https://cms.jewlr.com/${item.image.mobile}`,
        srcSet: [
          {
            height: 520,
            media: "(max-width: 767px)",
            sizes: "(max-width: 767px) 50vw",
            srcSet: getImgSrcSet(
              `${sl.config.jewlr_imgsmbly_url}cms/${item.image.mobile}`,
              335
            ),
            width: 335,
          },
          {
            height: 750,
            media: "(min-width: 768px)",
            sizes: "(max-width: 1920px) 25vw, 450px",
            srcSet: getImgSrcSet(
              `${sl.config.jewlr_imgsmbly_url}cms/${item.image.desktop}`,
              600
            ),
            width: 600,
          },
        ],
        url: item.url,
      },
      style: {
        container_style: {
          bg: "transparent",
          color: "white",
        },
      },
      title: item.title,
      url: item.url,
    })),
  },
  style: {
    block_style: {
      mb: { _: 3, tablet: "60px" },
      mt: { _: 3, tablet: 5 },
    },
  },
}

const ShopNowGrid = () => <FeatureGrid element={element} />

export default ShopNowGrid
